import React from "react"

export const Arrow = ({
  direction = "right",
  size = 1,
  color,
  className = "",
}) => {
  const rotiations = {
    down: 90,
    up: -90,
    left: 180,
    right: 0,
  }

  return (
    <svg
      className={className}
      width={40 * size}
      height={40 * size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        marginBottom: (7 * size) / 2,
        transform: `rotate(${rotiations[direction]}deg)`,
        transition: "all 0.2s ease",
        overflow: "visible",
        enableBackground: "new 0 0 16 16",
      }}
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h40v40H0z" />
        <path
          fill={!!color ? color : "#034055"}
          fillRule="nonzero"
          d="M27.768 18.438H6v3.625h21.768V27.5L35 20.25 27.768 13z"
        />
      </g>
    </svg>
  )
}
